import { ENV } from 'app.constants'

export const env = () => {
    const host = window.location.hostname
    const keyTyped = host as keyof typeof ENV
    return ENV[keyTyped]
}
